import user from './user'
import app from './app'
import module from './module'
import fun from './function'
import role from './role'
import auth from './auth'
import log from './log'
import setting from './setting'
import dictionary from './dictionary'

export default {
  user,
  app,
  module,
  function: fun,
  role,
  auth,
  log,
  setting,
  dictionary
}



// WEBPACK FOOTER //
// ./src/api/system/index.js